import React from 'react';
import classnames from 'classnames';
import {getBreakLinesTextShumaType3} from "../../../utils/texts";
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import styles from './styles.module.scss';

const Section8Text5 = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {identifyMethodType, rightsRegistryDesc} = context.data.pdfData;

  return (
    <div ref={ref}>
      {Boolean(rightsRegistryDesc) && identifyMethodType === 1 && (
        <div className={classnames(styles.itemText, styles.innerPadding)}>
          <span className={classnames(styles.bold, styles.itemNumber)}>-   </span>
          <span className={styles.bold}>תאור: </span>
          <span>{getBreakLinesTextShumaType3(rightsRegistryDesc)}</span>
        </div>
      )}
    </div>
  );
});

export default Section8Text5;
